export const SESSION_STORAGE_KEYS = {
  RENTAL_REQUEST_FLOW: 'klickrent.rentalRequestFlow.v1',
};
